<template>
<v-layout row wrap>
  <v-flex xs8 offset-xs2>
    <v-expansion-panel v-model="groups" expand>
      <v-expansion-panel-content v-for="item in stickers" :key="item.category">
        <template v-slot:header>
          <div>#Category: {{ item.category }}</div>
        </template>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs3 v-for="s in item.stickers" :key="s.text">
              <v-card color="purple" class="white--text">
                <v-layout row>
                  <v-flex xs7>
                    <v-card-title primary-title>
                      <div>
                        <div class="headline fix-text">{{ prefix }}{{ command }} {{ s.text }}</div>
                      </div>
                    </v-card-title>
                  </v-flex>
                  <v-flex xs5>
                    <v-img :src="`${s.url}`" height="125px" contain></v-img>
                  </v-flex>
                </v-layout>
                <v-divider light></v-divider>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-flex>
</v-layout>
</template>

<script>
import stickers from '../plugins/stickers.json'
const prefix = '>'
const command = 'e'
const fixToArray = Object.entries(stickers)
.map(a => { return { category: a[0], stickers: Object.entries(a[1])
.map(s => { return { text: s[0], url: s[1] }}) }})

export default {
  name: 'commands',
  data: () => ({
    stickers: fixToArray,
    groups: [],
    command: [],
    prefix,
    command
  }),
  methods: {
    FixPrefix (prefix) {
      return prefix.split('<prefix>').join(this.prefix)
    }
  }
}
</script>

<style scoped>
.fix-text {
  font-size: 18px !important
}
</style>
